import { AfterContentInit, Component, OnInit } from '@angular/core';
import {
  Router,
  NavigationEnd,
  NavigationStart,
  NavigationError,
} from '@angular/router';
import { AuthHelper } from 'src/helper/auth-helper';
import { CommonApiService } from 'src/helper/common-api.service';
import { CommonHelper } from 'src/helper/common-helper';
import { StaticPageJSHelper } from 'src/helper/javascript-shared-helper';
import { AuthService } from 'src/pages/admin/login/auth.service';
import { DialogServices } from 'src/pages/dialogService';
import { SeminarLoginComponent } from '../seminar-login/seminar-login.component';
import { AdminService } from 'src/pages/admin/admin.service';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'src/helper/message.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-static-header',
  templateUrl: './static-header.component.html',
  styleUrls: ['./static-header.component.css'],
})
export class StaticHeaderComponent implements OnInit {
  currentRoute: string;
  navbarCollapsed = true;
  isauth: any;
  username: any;
  editModelData: any;
  isseminar: any;
  profileForm!: FormGroup;
  image: any;
  imageSrc: string | ArrayBuffer | null;
  submitted: boolean;
  apiUrl = environment.blobUrl;


  constructor(
    private router: Router,
    private authService: AuthService,
    private dialogService: DialogServices,
    private adminservice: AdminService,
    private CommonApiService: CommonApiService,
    private messageService: MessageService,
    private modelService: NgbModal,
  ) {
    this.currentRoute = '';
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
      }

      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
      }

      if (event instanceof NavigationError) {
      }
    });
  }

  ngOnInit(): void {
    if (this.authService.isAuthenticated) {
      this.getProfile();
    }
    this.isseminar = localStorage.getItem('isseminar');
    this.isauth = this.authService.isAuthenticated;

  }

  resetLan() {
    var iframe = document.getElementsByClassName('goog-te-banner-frame')[0];
    if (!iframe) return;
    //@ts-ignore
    var innerDoc = iframe.contentDocument || iframe.contentWindow.document;
    var restore_el = innerDoc.getElementsByTagName('button');

    for (var i = 0; i < restore_el.length; i++) {
      if (restore_el[i].id.indexOf('restore') >= 0) {
        restore_el[i].click();
        var close_el = innerDoc.getElementsByClassName('goog-close-link');
        close_el[0].click();
        return;
      }
    }
  }

  loadForm(t: any) {
    this.profileForm = new FormGroup({
      firstName: new FormControl(t?.firstName, [Validators.required]),
      lastName: new FormControl(t?.lastName, [Validators.required]),
      //email: new FormControl({value : t?.email,disabled:true}, [Validators.required,  Validators.pattern(`[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}`)])
    });
  }

  onFileChange(event: any) {
    this.image = event.target.files[0];
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => (this.imageSrc = reader.result);
    reader.readAsDataURL(file);
  }

  openModel(model: any) {
    this.modelService.open(model);
    this.getProfile();
  }

  closeModel() {
    this.editModelData = null;
    this.getProfile();
    this.imageSrc = null;
    this.profileForm.reset();
    this.submitted = false;
    this.modelService.dismissAll();
  }

  handleProfileSubmit() {
    this.submitted = true;
    if (!this.image) {
      this.image = this.editModelData.profile;
    }

    if (
      this.profileForm.invalid ||
      this.image == null ||
      this.image == undefined
    ) {
      this.profileForm.markAllAsTouched();
      return;
    }

    const formData: FormData = new FormData();
    formData.append('image', this.image);
    formData.append('model', JSON.stringify(this.profileForm.value));

    this.CommonApiService.getPromiseResponse({
      apiName: `/api/${AuthHelper.UserDetails.AccountId}`,
      methodType: 'put',
      parameterObject: formData,
    })
      .then((result: any) => {
        // this.closeModel();
        this.getProfile();
        this.messageService.successMessage('Profile Updated Successfully');
      })
      .catch((err: any) => {
        // this.closeModel()
        if (err.message) {
          this.messageService.warningMessage(err.message);
        } else {
          this.messageService.warningMessage('Something went wrong!');
        }
      });
  }



  seminar() {
    if (this.authService.isAuthenticated) {
      if (this.isseminar == 'true') {
        this.router.navigate(['/session/dashboard/download-certificate']);
      }
      else {
        this.router.navigate(['/session/dashboard']);
      }

    }
    else {
      this.dialogService.addDialog(SeminarLoginComponent, { size: 'lg' }).result.then((result: any) => {
        if (result) {

        }
      });
    }
  }

  logout() {
    this.authService.logout();
    this.ngOnInit();
  }

  getProfile() {
    this.adminservice
      .getProfile(AuthHelper.UserDetails.AccountId)
      .then((result: any) => {
        this.editModelData = result;
        this.username = result.firstName + ' ' + result.lastName;
        this.loadForm(result);
      })
      .catch((err: any) => { });
  }

  isControlValid(controlName: string): boolean {
    const control = this.profileForm.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.profileForm.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation: any, controlName: string | number): boolean {
    const control = this.profileForm.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName: string | number): boolean {
    const control = this.profileForm.controls[controlName];
    return control.dirty || control.touched;
  }
}
